import React from "react";
import { useTranslate } from "@refinedev/core";
import {
  ChartBarIcon,
  GearIcon,
  PencilSimpleIcon,
  ExportIcon,
} from "@phosphor-icons/react";
import styled from "styled-components";
import type { CreatorToolbarProps } from "./CreatorToolbar";
import { radius } from "@libertify/ui";

const Wrapper = styled.div`
  flex-shrink: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 16px;
  background: white;
  border-bottom: 1px solid #f3f4f6;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

const LogoImg = styled.img`
  height: 22px;
  width: auto;
  flex-shrink: 0;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const GhostBtn = styled.button`
  border: 0;
  border-radius: ${radius.pill}px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;

  &:active {
    background: #f3f4f6;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 18px;
  background: #e5e7eb;
  margin: 0 2px;
  flex-shrink: 0;
`;

const ShareBtn = styled.button`
  background: #14b8a6;
  color: white;
  border: 2px solid #3bd4ca;
  border-radius: ${radius.pill}px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  flex-shrink: 0;

  &:active {
    background: #0d9488;
  }
`;

export const CreatorToolbarMobile: React.FC<CreatorToolbarProps> = ({
  isLive,
  onAnalyticsClick,
  onEditVideoClick,
  onEditClick,
  onShareClick,
  secondaryMenu,
  isHeyGenius,
  canEditVideo = true,
  outOfDateAction,
}) => {
  const t = useTranslate();

  const showFullActions = !isHeyGenius;

  return (
    <Wrapper>
      <LogoImg
        src="/images/Logo_Libertify_Horizontal_fond_blanc_RVB.png"
        alt="Libertify"
      />
      <RightGroup>
        {showFullActions && (
          <>
            <GhostBtn onClick={onAnalyticsClick}>
              <ChartBarIcon size={13} />
              {t("media.components.CreatorToolbar.analyticsShort")}
            </GhostBtn>
            {canEditVideo ? (
              <GhostBtn onClick={onEditVideoClick}>
                <PencilSimpleIcon size={13} />
                {t("media.components.CreatorToolbar.editShort")}
              </GhostBtn>
            ) : null}
          </>
        )}
        <GhostBtn onClick={onEditClick}>
          <GearIcon size={13} />
          {t("media.components.CreatorToolbar.settingsShort")}
        </GhostBtn>
        {showFullActions && (
          <>
            <Divider />
            <ShareBtn onClick={onShareClick}>
              <ExportIcon size={13} />
              {t("media.components.CreatorToolbar.shareShort")}
            </ShareBtn>
            {outOfDateAction}
          </>
        )}
        {secondaryMenu}
      </RightGroup>
    </Wrapper>
  );
};
